import { OIDCTokenSet } from 'infrastructure/oidc/OIDCClient';
import useSessionStorage from 'react-use/lib/useSessionStorage';
import { Optional } from 'utility/optional';
import { useMemo } from 'react';

const OIDC_TOKENS_KEY = 'jp.tier4.drive.autoware.auth.oidc.tokens';

type OIDCTokenSetData = Optional<OIDCTokenSet, 'expiresAt'>;

export function useSessionStorageForOIDCTokenSet() {
    const [rawTokenSet, storeTokenSet] = useSessionStorage<OIDCTokenSetData | null>(OIDC_TOKENS_KEY, null);

    const tokenSet = useMemo((): OIDCTokenSet | null => {
        return rawTokenSet ? { expiresAt: 0, ...rawTokenSet } : null;
    }, [rawTokenSet]);

    return { tokenSet, storeTokenSet };
}
